// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Tabs } from '@shared/ui-kit/components/tabs';
import { ModeledPortfolios } from './modeled-portfolios';
import { Translation } from '@shared/ui-kit/providers/translation-provider/translation';

export const Marketplace = () => {
  return (
    <Tabs.Root
      defaultValue="modeled-portfolios"
      className="mt-7"
      state-id="marketplace"
    >
      <Tabs.List>
        <Tabs.Trigger value="modeled-portfolios">
          <Translation i18nKey="research.modeled-portfolios" ns="research" />
        </Tabs.Trigger>
      </Tabs.List>

      <Tabs.Content value="modeled-portfolios">
        <ModeledPortfolios />
      </Tabs.Content>
    </Tabs.Root>
  );
};
